// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const pipCodeRequestItemToUpdate = item => ({
    item,
    type: actions.UPDATE_TCSM_PIP_CODE_REQUEST_ITEM_TO_UPDATE
});

export const updatePipCodeRequestTcsmComments = comments => ({
    comments,
    type: actions.UPDATE_TCSM_PIP_CODE_REQUEST_TCSM_COMMENTS
});



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/pip-code-request-item-to-update.js